import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const IconOverview = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
    <rect x="1" y="1" width="6" height="6" rx="1.5" />
    <rect x="9" y="1" width="6" height="6" rx="1.5" />
    <rect x="1" y="9" width="6" height="6" rx="1.5" />
    <rect x="9" y="9" width="6" height="6" rx="1.5" />
  </svg>
);

const IconUsers = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
    <circle cx="6" cy="5" r="2.5" />
    <path d="M1 13.5C1 11 3.24 9 6 9s5 2 5 4.5H1z" />
    <circle cx="12" cy="5.5" r="2" />
    <path d="M11.5 9c1.8.4 3.5 1.9 3.5 4.5H14c0-2.4-1.3-3.8-2.5-4.5z" />
  </svg>
);

const IconDashboards = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
    <path d="M2 9h3v5H2V9zm4-4h4v9H6V5zm5-3h3v12h-3V2z" />
  </svg>
);

const IconTokens = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
    <path fillRule="evenodd" d="M8 2a6 6 0 100 12A6 6 0 008 2zM0 8a8 8 0 1116 0A8 8 0 010 8z" />
    <path d="M8.5 5a.5.5 0 00-1 0v2.5H6a.5.5 0 000 1h2a.5.5 0 00.5-.5V5z" />
  </svg>
);

const IconLogout = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
    <path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3v-1.5H4V3.5h2V2zm3.854 2.646l3.5 3.5a.5.5 0 010 .708l-3.5 3.5-1.061-1.06L11.086 9H6V7h5.086L8.793 4.707l1.06-1.06z" />
  </svg>
);

const IconIssues = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
    <path d="M8 1a7 7 0 100 14A7 7 0 008 1zM0 8a8 8 0 1116 0A8 8 0 010 8z"/>
    <path d="M7.002 11a1 1 0 112 0 1 1 0 01-2 0zM7.1 4.995a.905.905 0 111.8 0l-.35 3.507a.552.552 0 01-1.1 0L7.1 4.995z"/>
  </svg>
);

const navItems = [
  { to: '/',              label: 'Overview',     icon: <IconOverview />,   exact: true },
  { to: '/users',         label: 'Users',        icon: <IconUsers /> },
  { to: '/dashboards',    label: 'Dashboards',   icon: <IconDashboards /> },
  { to: '/tokens',        label: 'Token Usage',  icon: <IconTokens /> },
  { to: '/issue-reports', label: 'Issue Reports',icon: <IconIssues /> },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        News<span className="accent">Pilot</span> Admin
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            {item.icon}
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        {user && (
          <>
            <div className="sidebar-user-name">{user.full_name}</div>
            <div className="sidebar-user-email">{user.email}</div>
            <button className="logout-btn" onClick={handleLogout}>
              <IconLogout />
              Sign out
            </button>
          </>
        )}
      </div>
    </aside>
  );
}
